module.exports = __webpack_public_path__ + "static/media/Alpogo.d273656c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/AppDevelopment/Alpogo.png
// module id = 458
// module chunks = 0